<div id="hablan-de-nosotros" class="py-5 px-2 px-lg-5 bg-primary-50">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-10 col-xl-8 mx-auto text-center">
        <p class="tab-ancla primary-500 mb-2">ÚLTIMOS ARTÍCULOS</p>
        <h1 class="primary-900">
          @if (!isCNMV) {
            Qué dicen de nosotros en<br>la prensa
          }
          @if (isCNMV) {
            Nuestras últimas rondas
          }
        </h1>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <div class="swiper swiperPrensaWeb" id="swiper-hablan">
          <div class="swiper-wrapper">
            @for (noticia of prensaWeb; track noticia) {
              <div class="containerImg col-lg-4 col-md-6 col-sm-12 swiper-slide">
                <div class="mb-3">
                  <img class="img-fluid" class="logo-size" src="{{noticia.logoFuente}}" alt="{{noticia.fuente}}"
                    title="{{noticia.fuente}}">
                  </div>
                  <p class="col-lg-12 primary-500 col-10 mx-auto p1-semiboldit mb-3">
                    {{noticia.descripcion | maxCharacters: 250}}
                  </p>
                  <a class="link1-bold primary-900 text-decoration-none" href="{{noticia.urlFuente}}" target="_blank">
                    {{noticia.fuente}}
                  </a>
                </div>
              }
            </div>
            <div class="mt-5">
              <div class="swiper-pagination swiper-pagination-prensa position-relative"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>